import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiConfig } from '@bonanza-social/toolkit/api';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import {
  appLogout,
  persistReducer,
  injectSlice,
} from '@bonanza-social/toolkit/state';
import { ChatState, Visibility } from './chat.types';
import ChatService from '../services/ChatService/ChatService';

export const groupUpdated = createAction<number>('chat/groupUpdated');

export const setVisibility = createAction<Visibility>('chat/setVisibility');

export const maximizeChat = createAction('chat/maximizeChat');

export const updateSessionVariables = createAction(
  'chat/updateSessionVariables',
);

export const fetchCustomerToken = createAsyncThunk(
  'chat/fetchCustomerToken',
  async () => {
    const userId = await apiConfig.getUserId();
    const data = await ChatService.getCustomerToken({
      pathParams: {
        userId: userId || '-1',
      },
    });

    return data;
  },
);

const initialState: ChatState = {
  auth: undefined,
  sessionFieldsTS: undefined,
};

const chat = createSlice({
  name: 'chat-web',
  initialState,
  reducers: {
    setSessionFieldsTS(state) {
      state.sessionFieldsTS = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerToken.fulfilled, (state, { payload }) => {
      state.auth = payload;
    });

    builder.addCase(appLogout, () => initialState);
  },
});

export const { setSessionFieldsTS } = chat.actions;

const persistConfig = {
  key: 'chat-web',
  storage: AsyncStorage,
  whitelist: ['sessionFieldsTS'],
};

const persistedReducer = persistReducer(persistConfig, chat.reducer);

export const withChat = injectSlice({
  reducerPath: 'chat-web',
  reducer: persistedReducer,
});

export const selectAuth = withChat.selector((state) => state['chat-web'].auth);

export const selectGroupId = () => { };

export const selectSessionFieldsTS = withChat.selector(
  (state) => state['chat-web'].sessionFieldsTS,
);

declare global {
  interface LazyLoadedSlices {
    'chat-web': ReturnType<typeof persistedReducer>;
  }
}
